import multiViewComponentsPaths from "@helpers/multiViewComponentsPaths/multiViewComponentsPaths";
import typesTiposUsuario from "@helpers/types/typesTiposUsuario";
import React from "react";
import { Col, Image, OverlayTrigger, Popover, Row, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaChartBar, FaGamepad, FaMailBulk, FaMapPin, FaPuzzlePiece, FaQrcode, FaTablet, FaUser } from "react-icons/fa";

const AtajosUsuarioPrimerIngreso = ({ handleChangeComponent, rol }) => {
    const {t} = useTranslation();
    const atajosItems = [
      

        {
            icon: <FaTablet size={25} />,
            titulo: t("Diagnostic test"),
            descripcion: t('Diagnostic description'),
            fondo: 'bg-diagnostico',
            handleComponent: 'examenDiagnostico',
            permittedTo: typesTiposUsuario.todosUsuarios,

        },
        {
            icon: <FaPuzzlePiece size={25} />,
            titulo: t("Learning paths"),
            descripcion: t('Learning description'),
            fondo: 'bg-ruta',
            handleComponent: 'rutasAprendizaje',
            permittedTo: typesTiposUsuario.todosUsuarios,

        },



    ]


    return (
        <>


            {atajosItems.map((atajo, idx) => (
                atajo.permittedTo.includes(rol) && (
                    <Col key={idx} className="mis-avances col-10 col-md-6 col-xl-4 col-xxl-3 p-3 atajo" style={{height: "200px"}}>
                        <Row className="h-100 pointer " onClick={() => handleChangeComponent(atajo.handleComponent) }>
                            <Col className="col-4 justify-content-center" style={{backgroundColor: "#ffcc00", borderRadius: "10px 0px 0px 10px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
                                {atajo.icon}
                            </Col>
                            <Col className={`text-center ${atajo.fondo}`} style={{borderRadius: "0px 10px 10px 0px", display: 'flex', flexDirection: "row", alignItems: 'center'}}>
                                <div className="d-flex flex-column text-start text-white">
                                    <h5>{atajo.titulo}</h5>
                                    <small>{atajo.descripcion}</small>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                )
            ))}

            
        </>
    );
};

export default AtajosUsuarioPrimerIngreso;
